import { until } from 'lit-html/directives/until';
import '../dropdown';
import '@modules/select';
import { generalAriaLabels } from '@modules/i18n-labels';
import '@modules/aofl-form';

export default (ctx, html) => html`
  <aofl-form>
    <form @submit="${ctx.submit}" class="${ctx.searchFilters.length > 0 ? 'filter-active' : ''}">
      <div class="mb-3">
        ${(ctx.searchFilters.length > 0) ? html`
          <div class="font-weight-semibold d-inline-block align-middle">${until(ctx.__('<tt-kqAMxe0B>', 'Search By:'))}</div>
          ${ctx.searchFilters.map((item) => html`
            <label class="radio-inline align-middle mb-0 mr-2 leading-0">
              <input type="radio" data-bi-id="${item.biId}"
                   @input=${ctx.filterChangedHandler}
                   name="search[field]"
                   value="${item.field}"
                   .checked=${item.selected}> ${until(item.label)}
            </label>
          `)}
        ` : ''}
        </div>
      <div class="form-group search-form-group m-0">
        <input type="text" name="q" autocomplete="off" class="form-control" placeholder="${ctx.placeholder}"
               @input="${ctx.inputHandler}" title="${ctx.placeholder}" .value="${ctx.searchString}">
        <div class="search-btns">
          <button type="submit" aria-label="${until(generalAriaLabels.SEARCH)}" class="btn"><span
            class="ai ai-search align-middle"></span></button>
        </div>
      </div>
    </form>
  </aofl-form>
`;
